<script>
import Layout from "@/router/layouts/main";
import Stat from "@/components/widgets/stat";
import ModalAdd from "@/components/_exclusaoindividual/modal-add";
import ModalView from "@/components/_exclusaoindividual/modal-view";
import ModalPendings from "@/components/_exclusaoindividual/modal-pendings";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
    Stat,
    ModalAdd,
    ModalView,
    ModalPendings,
  },
  data() {
    return {
      filter: {
        list: "all",
        sign: "all",
        status: "all",
      },

      search: "",

      lists: null,

      statData: [
        { type: "line", icon: "bx-user-plus", title: "Disponível", value: "-" },
        { type: "line", icon: "bx-user-x", title: "Pendentes", value: "-" },
        { type: "line", icon: "bx-user-check", title: "Aprovados", value: "-" },
      ],

      fields: [
        { key: "name", label: "Nome / Razão Social" },
        { key: "person_number", label: "CPF / CNPJ" },
        { key: "city_state", label: "Cidade/UF" },
        { key: "docs", label: "Documentos" },
        { key: "status", label: "Status" },
        { key: "refazer", label: "" },
        { key: "observations", label: "" },
        { key: "list", label: "Lista" },
        { key: "actions", label: "", tdClass: 'text-right' },
      ],

      total: 0,
      currentPage: "1",
      perPage: "25",

      balance: {
        available: 0,
        blocked: 0,
      },

      clients: null,

      add: {
        modal: false,
      },

      view: {
        modal: false,
        client: {},
      },

      pendings: {
        modal: false,
      },
    };
  },
  methods: {
    // Força o ciclo false → true para o modal abrir mesmo se a flag ficou dessincronizada
    openModal(target) {
      target.modal = false;

      this.$nextTick(() => {
        target.modal = true;
      });
    },
    getClients() {
      this.clients = null;

      api
        .get("exclusaoindividual/clients?list=" + this.filter.list + "&sign=" + this.filter.sign + "&status=" + this.filter.status)
        .then((response) => {
          if (response.data.status == "success") {
            this.lists = response.data.lists;
            this.total = response.data.list.length;

            this.balance.available = response.data.balance.available;
            this.balance.blocked = response.data.balance.blocked;

            this.statData = [
              { type: "line", icon: "bx-user-plus", title: "Disponível", value: response.data.balance.available.toString() },
              { type: "line", icon: "bx-user-x", title: "Pendentes", value: response.data.total.pending.toString() },
              { type: "line", icon: "bx-user-check", title: "Aprovados", value: response.data.total.approved.toString() },
            ];

            this.clients = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.clients = [];
          }
        })
    },
    showImport() {
      this.$router.push('/exclusaoindividual/importacoes');
    },
    showView(client) {
      this.view.client = client;
      this.openModal(this.view);
    },
    exportClients() {
      api
      .get('exclusaoindividual/clients/export?list=' + this.filter.list + '&sign=' + this.filter.sign + '&status=' + this.filter.status)
      .then((response) => {
        if (response.data.status == "success") {
          const fileBase64 = response.data.base64;
          const mimeType = response.data.mimetype || 'application/octet-stream';
          const filename = response.data.filename || 'relatorio.xlsx';

          const byteCharacters = atob(fileBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          const blob = new Blob([byteArray], { type: mimeType });

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(link.href);

          this.$toast.success("A lista de clientes foi exportada com sucesso!");
        } else {
          this.$toast.error(response.data.message);
        }
      });
    },
  },
  mounted() {
    this.getClients();
  },
  watch: {
    "filter.list": function () {
      this.getClients();
    },
    "filter.sign": function () {
      this.getClients();
    },
    "filter.status": function () {
      this.getClients();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Exclusão Individual</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Clientes</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-6 col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light">
        <template #button-content>
          ações
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-item v-on:click="openModal(add);">Novo</b-dropdown-item>
        <b-dropdown-item v-on:click="showImport();">Importar</b-dropdown-item>
        <b-dropdown-item v-on:click="openModal(pendings);">Pagar</b-dropdown-item>
        <b-dropdown-item v-on:click="exportClients();">Exportar</b-dropdown-item>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Listas</h6>
              <div v-if="filter.list == 'all'">Todos</div>
              <div v-else-if="lists.find(list => list.id === filter.list)">{{lists.find(list => list.id === filter.list).name }}</div>
              <div v-else>–</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form>
          <b-form-radio v-model="filter.list" value="all">Todos</b-form-radio>
        </b-dropdown-form>
        <b-dropdown-form v-for="list of lists" :key="list.id">
          <b-form-radio v-model="filter.list" :value="list.id">{{ list.name }}</b-form-radio>
        </b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Status</h6>
              <div v-if="filter.status == 'all'">Todos</div>
              <div v-else-if="filter.status == 'pending'">Pendente</div>
              <div v-else-if="filter.status == 'approved'">Pago</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="all">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="pending">Pendente</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="approved">Pago</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <div class="totals">
        <h6 class="m-0 text-secondary text-lowercase">Total</h6>
        <div>{{ total }}</div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!clients">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="clients && clients.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">

          <b-input v-model="search" placeholder="Busca" class="mb-4"></b-input>

          <b-table :items="clients" :fields="fields" class="table-nowrap table-style table-hover table-pointer min-vh-25" head-variant="light" @row-clicked="showView" :current-page="currentPage"
            :per-page="perPage" :filter="search" responsive>
            <template #cell(city_state)="row">
              <span v-if="row.item.city">{{ row.item.city }}/{{ row.item.state }}</span>
            </template>
            <template #cell(docs)="row">
              <div class="d-flex align-items-center flex-gap-5">
                <div v-for="(doc, index) in row.item.docs" :key="index">
                  <span class="d-inline-block bg-danger rounded" style="width: 14px; height: 14px;" v-if="doc == 'pending'"></span>
                  <span class="d-inline-block bg-info rounded" style="width: 14px; height: 14px;" v-else-if="doc == 'sent'"></span>
                  <span class="d-inline-block bg-success rounded" style="width: 14px; height: 14px;" v-else-if="doc == 'signed'"></span>
                  <span class="d-inline-block bg-danger rounded" style="width: 14px; height: 14px;" v-else-if="doc == 'refused'"></span>
                  <span class="d-inline-block bg-warning rounded" style="width: 14px; height: 14px;" v-else-if="doc == 'uploaded'"></span>
                  <span class="d-inline-block bg-success rounded" style="width: 14px; height: 14px;" v-else-if="doc == 'approved'"></span>
                  <span class="d-inline-block bg-danger rounded" style="width: 14px; height: 14px;" v-else-if="doc == 'rejected'"></span>
                </div>
              </div>
            </template>
            <template #cell(status)="row">
              <span class="badge badge-soft-danger font-size-13" v-if="row.item.status == 'pending'">PENDENTE</span>
              <span class="badge badge-soft-success font-size-13" v-else-if="row.item.status == 'approved'">PAGO</span>
              <span class="badge badge-soft-warning font-size-13" v-else-if="row.item.status == 'deleted'">EXCLUÍDO</span>
              <span class="badge badge-soft-warning font-size-13" v-else-if="row.item.status == 'canceled'">CANCELADO</span>
            </template>
            <template #cell(refazer)="row">
              <div v-if="row.item.refazer_status == 'new'" class="text-success" title="Gerado pelo refazer">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                  <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4z"></path>
                </svg>
              </div>
            </template>
            <template #cell(observations)="row">
              <div v-if="row.item.observations">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"></path>
                  <path d="M11 11h2v6h-2zm0-4h2v2h-2z"></path>
                </svg>
              </div>
            </template>
            <template #cell(list)="row">
              <div v-if="row.item.list && row.item.status == 'approved'" class="d-flex align-items-center flex-gap-5">
                <small class="py-2 align-top">{{ row.item.list.name }}</small>
              </div>
            </template>
            <template #cell(actions)="row">
              <div v-if="row">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                  <path d="M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"></path>
                  <path
                    d="M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z">
                  </path>
                </svg>
              </div>
            </template>
          </b-table>

          <b-pagination v-if="search == ''" class="mt-4" v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center"></b-pagination>
        </div>
      </div>
    </div>

    <ModalAdd :modal.sync="add.modal" @added="getClients" />

    <ModalView :modal.sync="view.modal" :client="view.client" @reload="getClients" />

    <ModalPendings :modal.sync="pendings.modal" :available="balance.available" @paid="getClients" />
  </Layout>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>
